import {
  IManagerLegacyNavTranslations,
  IEventManagerHomeTranslations,
  IEventManagerExhibitorsTranslations,
  IEventManagerProductsTranslations,
  IEventManagerSessionsTranslations,
  IEventManagerExportsTranslations,
  IEventManagerEventsTranslations,
  IManagerTranslations,
} from '@/translations/default/managers';

const legacy_nav: Partial<IManagerLegacyNavTranslations> = {
  product_form: 'Stellenangebotsformular',
  product_list: 'Stellenausschreibungen',
  product_categories: 'Job-Kategorien',
};

const home: Partial<IEventManagerHomeTranslations> = {
  products_subtitle: 'Anzahl der geschaffenen Stellenangebote',
};

const exhibitors: Partial<IEventManagerExhibitorsTranslations> = {
  products_limit_label: 'Grenzen des Stellenangebots',
  products_limit_message: 'Maximale Anzahl von Stellenangeboten, die ein Aussteller erstellen kann',
};

const products: Partial<IEventManagerProductsTranslations> = {
  empty_list_categories_subtitle: 'Produktkategorien hinzufügen',
  empty_list_product_title: 'Produkt',
  empty_list_product_subtitle: 'Ein neues Produkt erstellen',
  title: 'Freie Stellen verfügbar',
  subtitle: 'Zahl der geschaffenen Arbeitsplätze',
};

const sessions: Partial<IEventManagerSessionsTranslations> = {
  // leave empty until needed
};

const exports: Partial<IEventManagerExportsTranslations> = {
  // leave empty until needed
};

const events: Partial<IEventManagerEventsTranslations> = {
  // leave empty until needed
};

const managers: DeepPartial<IManagerTranslations> = {
  legacy_nav,
  home,
  exhibitors,
  products,
  sessions,
  exports,
  events,
};

export default managers;
